import { Section, Field, ControlType } from "@cotecna/dynamic-view-engine";

export const IMPORT_EVENT_FIELDS: Field[] = [
  {
    id: "inspectionId",
    type: ControlType.Dropdown,
    label: "Inspection ID",
    order: 1,
    propertyName: "inspectionId",
    value: "",
    readableValue: "",
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "primaryItem",
    type: ControlType.Dropdown,
    label: "Primary Item",
    order: 2,
    propertyName: "primaryItem",
    value: "",
    readableValue: "",
    required: true,
    visible: true,
    valid: false,
  },
  {
    id: "currentInspecionItem",
    type: ControlType.Dropdown,
    label: "Current Inspection Item",
    order: 3,
    propertyName: "currentInspecionItem",
    value: "",
    readableValue: "",
    required: true,
    visible: false,
    valid: true,
  },
];

export const IMPORT_EVENT_SECTIONS: Section[] = [
  {
    id: "1",
    name: "",
    order: 1,
    isFixed: true,
    fields: IMPORT_EVENT_FIELDS,
    actions: [],
  },
];

export const IMPORT_EVENT_CONTROLS: any[] = [
  {
    id: "inspectionId",
    options: [],
  },
  {
    id: "primaryItem",
    options: [],
  },
  {
    id: "currentInspecionItem",
    options: [],
  },
];
